import React from 'react';
import PropTypes from 'prop-types';

import { Center, Loader, Text } from '@mantine/core';

export const ActivityIndicator = ({ label, ...rest }) => {
    return (
        <Center>
            <Loader {...rest} />
            <Text ml="sm">{label}</Text>
        </Center>
    );
};

ActivityIndicator.propTypes = {
    label: PropTypes.string,
};
